export default __webpack_public_path__ + "static/media/Textilslöjd4.eec49f79.jpeg";